module Client.QRC

open Fable.Core
open Fable.Core.JsInterop
open Fable.Import

[<ImportMember("qrcode")>]
let toDataURL(encoded: string) (callback: System.Func<obj, string, unit>) = jsNative

let getDataUrl encoded =
    let mutable ret = ""
    toDataURL
        encoded
        (System.Func<obj, string, unit>(fun _ url -> ret <- url))
    ret
    